import moment from 'moment';

export const secondsToDuration = seconds => moment
  .utc(seconds * 1000)
  .format('HH:mm:ss');
